import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { resetPwd } from "@/api/api-basic";
import { State, Mutation } from "vuex-class";
import { getAlarmSummaryFilter, getAlarmCountSave } from "@/api/api-basic";
import { getOperBacklog } from "@/api/api-operation-service";
import resetPassword from "../reset-password/reset-password.vue";
import i18n from "@/config/i18n";
let PiHeader = class PiHeader extends Vue {
    constructor() {
        super(...arguments);
        this.time = "";
        this.navIndex = 1;
        this.msgNum = 0; // 未处理通知
        this.visible = false;
        this.isShowResPassword = false;
        this.msgTipsList = [
            {
                key: "abnormalOrder",
                name: i18n.t("header.abnormalOrder"),
                url: "/oper-manage/order-manage/charge-order-list?orderStatus=4&startDate=&endDate=",
            },
            {
                key: "campaignAmount",
                name: i18n.t("header.campaignAmount"),
                url: "/oper-manage/marketing/member-coupon?applyStatus=2",
            },
            {
                key: "couponTemplateAmount",
                name: i18n.t("header.couponTemplateAmount"),
                url: "/oper-manage/marketing/coupon?applyStatus=2",
            },
            {
                key: "feeAmount",
                name: i18n.t("header.feeAmount"),
                url: "/oper-manage/fee-manage/charge-fee?applyStatus=1",
            },
            {
                key: "invoiceAmount",
                name: i18n.t("header.invoiceAmount"),
                url: "/mch-center/invoice-manage?applyStatus=0",
            },
            {
                key: "mchDrawcashOrder",
                name: i18n.t("header.mchDrawcashOrder"),
                url: "/mch-center/mch-withdrawal",
            },
            {
                key: "mchSettlementOrder",
                name: i18n.t("header.mchSettlementOrder"),
                url: "/mch-center/merchant-sharing?orderStatus=1",
            },
            {
                key: "memberMsgAmount",
                name: i18n.t("header.memberMsgAmount"),
                url: "/oper-manage/message/customer-service",
            },
            {
                key: "rechargeApplyAmount",
                name: i18n.t("header.rechargeApplyAmount"),
                url: "/mch-center/recharge-manage?orderStatus=3",
            },
            {
                key: "refundOrder",
                name: i18n.t("header.refundOrder"),
                url: "/mch-center/refund-manage?orderStatus=3",
            },
            {
                key: "staAmount",
                name: i18n.t("header.staAmount"),
                url: "/pile-manage/pile-info",
            },
            {
                key: "unusedEquipmentAmount",
                name: i18n.t("header.unusedEquipmentAmount"),
                url: "/pile-manage/pile-list",
            },
        ];
        this.msgTipsListShow = [];
    }
    getIsLogin(val) {
        if (val) {
            this.getAlarmSummary();
            this.getOperBacklog();
        }
    }
    getVisible(val) {
        if (val) {
            this.getOperBacklog();
        }
    }
    /**
     * 退出登录
     */
    goOut() {
        this.$Modal.confirm({
            title: i18n.t("tips") + "",
            content: i18n.t("header.outConfirm") + "",
            onOk: () => {
                this.$common.out();
            },
        });
    }
    /**
     * 返回子级路径
     */
    privilegeVoList(privilegeVoList) {
        let isUrl = false;
        privilegeVoList.map((child) => {
            if (child.privilegeCode == "100501" && child.checked) {
                isUrl = true;
            }
        });
        return isUrl;
    }
    /**
     * 导航点击,要跳转子菜单中的第一个有权限有路径,没有子菜单就跳转自己的路径
     */
    navClick(item) {
        if (item.children && item.children.length > 0) {
            let url = "";
            item.children.map((itemData) => {
                if (itemData.children && item.children.length > 0 && url == "") {
                    itemData.children.map((itemDataChild) => {
                        const list = itemDataChild.privilegeVoList || [];
                        if (this.privilegeVoList(list) && url == "") {
                            url = itemDataChild.url;
                        }
                    });
                }
                else if (url == "") {
                    const list = itemData.privilegeVoList || [];
                    if (this.privilegeVoList(list)) {
                        url = itemData.url;
                    }
                }
            });
            if (this["$route"].path != url) {
                this.$router.push(url);
            }
        }
        else {
            this["$router"].push(item.url);
        }
    }
    /**
     * 跳转大屏
     */
    goHome() {
        const url = this["$route"].path;
        if (url != "/home/index/home-data" && this.$config.isHomeData) {
            this["$router"].push("/home/index/home-data");
        }
    }
    /**
     * 获取告警信息,存到vuex 里
     */
    async getAlarmSummary() {
        const day = new Date(new Date().setDate(new Date().getDate() - 6));
        const startTime = this.$common.userDate(day);
        const endTime = this.$common.userDate(new Date());
        const ret = await getAlarmSummaryFilter({
            startTime: startTime,
            endTime: endTime,
        });
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data[0];
            this.SET_ALARM(data);
        }
    }
    /**
     * 获取等处理消息
     */
    async getOperBacklog() {
        const ret = await getOperBacklog({});
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data[0];
            this.msgNum = data.totalAmount || 0;
            const msgTipsListShow = [];
            this.msgTipsList.map((item) => {
                let itemData = {};
                for (const i in data) {
                    if (i == item.key) {
                        item.value = data[i];
                        const url = item.url.split("?")[0];
                        if (item.value > 0 && this.$config.autoUrl[url]) {
                            // 找出有权限的消息
                            itemData = item;
                        }
                    }
                }
                if (itemData.url) {
                    msgTipsListShow.push(item);
                }
            });
            this.msgTipsListShow = msgTipsListShow;
        }
    }
    /**
     * 账号信息跳转
     */
    queryAccInfo() {
        this.$router.push("/account/info");
    }
    /**
     * 修改密码点击
     */
    updataPassword() {
        this.isShowResPassword = true;
    }
    /**
     * 修改密码提交
     */
    async resetPasswordData(data) {
        const params = {
            userPkId: this.sys.userInfo.userPkId,
            userPwd: data.password,
        };
        const ret = await resetPwd(params);
        if (ret.status == this["$config"].apiStatus) {
            this.isShowResPassword = false;
            this.$Modal.success({
                title: i18n.t("tips") + "",
                content: i18n.t("header.upSuccess") + "",
                onOk: () => {
                    this.$common.out();
                },
            });
        }
    }
    /**
     * 去告警页面
     */
    async goAlarmPage(item) {
        let url = this.$route.path;
        if (url != "/alarm-event") {
            let ret = await getAlarmCountSave({ alarmLevel: item.id });
            if (ret.status == this.$config.apiStatus) {
                this.$router.push("/alarm-event?alarmLevel=" + item.id);
            }
        }
        else {
            this.SET_ALARMLEVER(item.id);
        }
    }
    msgClick(url) {
        this.$router.push(url);
        this.visible = false;
    }
    mounted() {
        if (this.isLogin) {
            this.getAlarmSummary();
            this.getOperBacklog();
        }
        this.time = this.$common.thisTimes("yyyy-MM-dd HH:MM");
    }
};
__decorate([
    Prop({ default: "" })
], PiHeader.prototype, "menuId", void 0);
__decorate([
    Prop({ default: false })
], PiHeader.prototype, "isLogin", void 0);
__decorate([
    Mutation("SET_ALARM")
], PiHeader.prototype, "SET_ALARM", void 0);
__decorate([
    Mutation("SET_ALARMLEVER")
], PiHeader.prototype, "SET_ALARMLEVER", void 0);
__decorate([
    Watch("isLogin")
], PiHeader.prototype, "getIsLogin", null);
__decorate([
    Watch("visible")
], PiHeader.prototype, "getVisible", null);
__decorate([
    State("sys")
], PiHeader.prototype, "sys", void 0);
__decorate([
    State("sysMsg")
], PiHeader.prototype, "sysMsg", void 0);
PiHeader = __decorate([
    Component({
        components: {
            resetPassword,
        },
    })
], PiHeader);
export default PiHeader;
